import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import SupabaseBackend from './supabase-backend'

const isBrowser = typeof window !== 'undefined'

// Endast använd Supabase backend för admin-sidor
const useSupabaseBackend = isBrowser && window.location.pathname.startsWith('/admin')

// Enkel backend som inte försöker ladda filer för publika sidor
const noOpBackend = {
  type: 'backend',
  init: () => {},
  read: (language, namespace, callback) => {
    // Returnera tom data för publika sidor
    callback(null, {})
  }
}

i18n
  .use(useSupabaseBackend ? SupabaseBackend : noOpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    react: {
      useSuspense: false,
    },
  })

export default i18n